import { createSlice } from "@reduxjs/toolkit";

import { 
    InitialState
} from "../../types/budgetData";

/*import { 
    STORAGE_KEY_BUDGET_ACCOUNTS,
    STORAGE_KEY_BUDGET_TAGS,
    STORAGE_KEY_BUDGET_CATEGORIES,
    STORAGE_KEY_BUDGET_ITEMS,
    STORAGE_KEY_BUDGET_TRANSACTIONS
} from "../../constants/global"*/

//const storedUser = localStorage.getItem(STORAGE_KEY_USER_PROFILE)

const initialState: InitialState = {
    accounts: [],
    categories: [],
    items: [],
    tags: [],
    transactions: []
}

export const budgetDataSlice = createSlice({
    name: "budgetData",
    initialState: initialState,
    reducers: {

        setAccounts: (state, action) => {
            //const localList = JSON.parse(localStorage.getItem(STORAGE_KEY_BUDGET_ACCOUNTS) || '[]')
            //localStorage.setItem(STORAGE_KEY_BUDGET_ACCOUNTS, JSON.stringify(action.payload))
            state.accounts = action.payload;
        },
        createAccount: (state, action) => {
            state.accounts = [...state.accounts, action.payload]
        },
        updateAccount: (state, action) => {
            state.accounts = state.accounts.map((obj) => obj._id === action.payload._id? action.payload : obj)
        },
        deleteAccount: (state, action) => {
            state.accounts = state.accounts.filter(item => item._id !== action.payload._id)
        },

        setTags: (state, action) => {
            //const localList = JSON.parse(localStorage.getItem(STORAGE_KEY_BUDGET_TAGS) || '[]')
            //localStorage.setItem(STORAGE_KEY_BUDGET_TAGS, JSON.stringify(action.payload))
            state.tags = action.payload;
        },
        createTag: (state, action) => {
            state.tags = [...state.tags, action.payload]
        },
        updateTag: (state, action) => {
            state.tags = state.tags.map((obj) => obj._id === action.payload._id? action.payload : obj)
        },
        deleteTag: (state, action) => {
            state.tags = state.tags.filter(item => item._id !== action.payload._id)
        },

        setCategories: (state, action) => {
            //const localList = JSON.parse(localStorage.getItem(STORAGE_KEY_BUDGET_CATEGORIES) || '[]')
            //localStorage.setItem(STORAGE_KEY_BUDGET_CATEGORIES, JSON.stringify(action.payload))
            state.categories = action.payload;
        },
        createCategory: (state, action) => {
            state.categories = [...state.categories, action.payload]
        },
        updateCategory: (state, action) => {
            state.categories = state.categories.map((obj) => obj._id === action.payload._id? action.payload : obj)
        },
        deleteCategory: (state, action) => {
            state.categories = state.categories.filter(item => item._id !== action.payload._id)
        },

        setItems: (state, action) => {
            //const localList = JSON.parse(localStorage.getItem(STORAGE_KEY_BUDGET_ITEMS) || '[]')
            //localStorage.setItem(STORAGE_KEY_BUDGET_ITEMS, JSON.stringify(action.payload))
            state.items = action.payload;
        },
        createItem: (state, action) => {
            state.items = [...state.items, action.payload]
        },
        updateItem: (state, action) => {
            state.items = state.items.map((obj) => obj._id === action.payload._id? action.payload : obj)
        },
        deleteItem: (state, action) => {
            state.items = state.items.filter(item => item._id !== action.payload._id)
        },

        setTransactions: (state, action) => {
            //const localList = JSON.parse(localStorage.getItem(STORAGE_KEY_BUDGET_TRANSACTIONS) || '[]')
            //localStorage.setItem(STORAGE_KEY_BUDGET_TRANSACTIONS, JSON.stringify(action.payload))
            state.transactions = action.payload;
        },
        createTransaction: (state, action) => {
            state.transactions = [...state.transactions, action.payload].sort((a, b) => b.dateAt - a.dateAt);
        },
        updateTransaction: (state, action) => {
            state.transactions = state.transactions.map((obj) => obj._id === action.payload._id? action.payload : obj)
        },
        deleteTransaction: (state, action) => {
            state.transactions = state.transactions.filter(item => item._id !== action.payload._id)
        },
    },
});

export const { 
    setAccounts, 
    createAccount,
    updateAccount, 
    deleteAccount,

    setCategories,
    createCategory,
    updateCategory,
    deleteCategory,

    setItems,
    createItem,
    updateItem,
    deleteItem,

    setTags,
    createTag,
    updateTag,
    deleteTag,

    setTransactions,
    createTransaction,
    updateTransaction,
    deleteTransaction       
} = budgetDataSlice.actions;

export default budgetDataSlice.reducer;